import { PageType } from "shared/lib/page-type";

export const pathname = "/author";

export const page = {
  route(query: QueryParameters<{ entityId: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Author },
    };
  },
};
